module.exports = __webpack_public_path__ + "static/media/042-jordan.d00f5e2a.svg";